// import React from 'react';

// // Same bucket prefix used elsewhere in the project
// export const S3_BASE_URL = 'https://s3.ap-south-1.amazonaws.com/bucket.gigbig/';

// export const genId = () => `b_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

// export const ADD_TYPES = ['banner', 'heading', 'text', 'image', 'button', 'columns', 'divider', 'spacer', 'social', 'footer'];
// // Types allowed INSIDE a column (no nested columns)
// export const CHILD_ADD_TYPES = ['heading', 'text', 'image', 'button', 'divider', 'spacer'];

// export const TYPE_LABELS = {
//   banner: '▬ Banner',
//   heading: 'H Heading',
//   text: '¶ Text',
//   image: '▦ Image',
//   button: '▶ Button',
//   columns: '⊞ Columns',
//   divider: '— Divider',
//   spacer: '↕ Spacer',
//   social: '◎ Social',
//   footer: '▪ Footer',
// };

// export const defaultBlock = (type) => {
//   const id = genId();
//   switch (type) {
//     case 'banner':
//       return { id, type, text: 'Your Banner Text', bgColor: '#3b82f6', textColor: '#ffffff', height: 120, align: 'center' };
//     case 'heading':
//       return { id, type, text: 'Heading text', align: 'left', color: '#111111', fontSize: 28 };
//     case 'text':
//       return { id, type, content: 'Write something here...', align: 'left', color: '#333333', fontSize: 16 };
//     case 'image':
//       return { id, type, src: '', alt: '', width: 100, align: 'center', isUploading: false };
//     case 'button':
//       return { id, type, label: 'Click Here', url: '#', bgColor: '#2563eb', textColor: '#ffffff', align: 'left' };
//      case 'columns':
//       return {
//         id,
//         type,
//         gap: 8,
//         rowBackground: 'transparent',
//         columns: [
//           { id: genId(), width: 50, background: '#ffffff', blocks: [] },
//           { id: genId(), width: 50, background: '#ffffff', blocks: [] },
//         ],
//       };
//     case 'divider':
//       return { id, type, color: '#e5e7eb', thickness: 1 };
//     case 'spacer':
//       return { id, type, height: 24 };
//     case 'social':
//       return { id, type, align: 'center', links: [{ platform: 'Facebook', url: '#' }, { platform: 'Instagram', url: '#' }] };
//     case 'footer':
//       return { id, type, text: '© Your Company', bgColor: '#111111', textColor: '#ffffff' };
//     default:
//       return { id, type: 'text', content: '' };
//   }
// };

// const resolveImageSrc = (src) => {
//   if (!src) return '';
//   if (src.startsWith('blob:') || src.startsWith('data:') || src.startsWith('http')) {
//     return src;
//   }
//   return `${S3_BASE_URL}${src}`;
// };

// export const BlockContent = ({ block }) => {
//   switch (block.type) {
//     case 'banner':
//       return (
//         <div
//           style={{
//             background: block.bgColor,
//             color: block.textColor,
//             minHeight: block.height,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: block.align === 'center' ? 'center' : block.align === 'right' ? 'flex-end' : 'flex-start',
//             padding: '16px 24px',
//             fontSize: 22,
//             fontWeight: 600,
//             textAlign: block.align,
//           }}
//         >
//           {block.text}
//         </div>
//       );

//     case 'heading':
//       return (
//         <div style={{ padding: '12px 20px' }}>
//           <h2 style={{ color: block.color, fontSize: block.fontSize, textAlign: block.align, margin: 0 }}>{block.text}</h2>
//         </div>
//       );

//     case 'text':
//       return (
//         <div style={{ padding: '8px 20px' }}>
//           <p style={{ color: block.color, fontSize: block.fontSize, textAlign: block.align, margin: 0, whiteSpace: 'pre-wrap' }}>
//             {block.content}
//           </p>
//         </div>
//       );

//     case 'image': {
//       const resolvedSrc = resolveImageSrc(block.src);
//       return (
//         <div style={{ padding: '8px 20px', textAlign: block.align, position: 'relative' }}>
//           {resolvedSrc ? (
//             <div style={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
//               <img
//                 src={resolvedSrc}
//                 alt={block.alt || ''}
//                 style={{
//                   width: `${block.width}%`,
//                   maxWidth: '100%',
//                   borderRadius: 6,
//                   opacity: block.isUploading ? 0.5 : 1,
//                   transition: 'opacity 0.2s',
//                 }}
//               />
//               {block.isUploading && (
//                 <div
//                   style={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: '50%',
//                     transform: 'translate(-50%, -50%)',
//                     background: 'rgba(0,0,0,0.6)',
//                     color: '#fff',
//                     fontSize: 11,
//                     padding: '4px 10px',
//                     borderRadius: 4,
//                   }}
//                 >
//                   Uploading...
//                 </div>
//               )}
//             </div>
//           ) : (
//             <div className="text-muted border rounded p-4 small text-center">Image not set</div>
//           )}
//         </div>
//       );
//     }

//     case 'button':
//       return (
//         <div style={{ padding: '12px 20px', textAlign: block.align }}>
//           <a
//             href={block.url}
//             onClick={(e) => e.preventDefault()}
//             style={{
//               display: 'inline-block',
//               background: block.bgColor,
//               color: block.textColor,
//               padding: '10px 22px',
//               borderRadius: 6,
//               textDecoration: 'none',
//               fontWeight: 600,
//             }}
//           >
//             {block.label}
//           </a>
//         </div>
//       );

//     case 'columns':
//       return (
//         <div style={{ display: 'flex', gap: block.gap, background: block.rowBackground, padding: 8 }}>
//           {block.columns.map((col) => (
//             <div key={col.id} style={{ width: `${col.width}%`, background: col.background, minHeight: 40 }}>
//               {col.blocks.map((child) => (
//                 <BlockContent key={child.id} block={child} />
//               ))}
//             </div>
//           ))}
//         </div>
//       );

//     case 'divider':
//       return (
//         <div style={{ padding: '10px 20px' }}>
//           <hr style={{ border: 'none', borderTop: `${block.thickness}px solid ${block.color}`, margin: 0 }} />
//         </div>
//       );

//     case 'spacer':
//       return <div style={{ height: block.height }} />;

//     case 'social':
//       return (
//         <div style={{ padding: '12px 20px', textAlign: block.align }}>
//           {block.links.map((l, i) => (
//             <a
//               key={i}
//               href={l.url}
//               onClick={(e) => e.preventDefault()}
//               style={{ marginRight: 12, fontWeight: 600, color: '#2563eb', textDecoration: 'none' }}
//             >
//               {l.platform}
//             </a>
//           ))}
//         </div>
//       );

//     case 'footer':
//       return (
//         <div style={{ background: block.bgColor, color: block.textColor, padding: '16px 20px', textAlign: 'center', fontSize: 13 }}>
//           {block.text}
//         </div>
//       );

//     default:
//       return null;
//   }
// };




// import React from 'react';

// // Same bucket prefix used elsewhere in the project
// export const S3_BASE_URL = 'https://s3.ap-south-1.amazonaws.com/bucket.gigbig/';

// export const genId = () => `b_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

// // ⭐ NEW — text ke andar [label](url) syntax ko clickable <a> tag mein convert karta hai
// const LINK_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/g;

// export const renderTextWithLinks = (text) => {
//   if (!text) return null;
//   const parts = [];
//   let lastIndex = 0;
//   let match;
//   let key = 0;
//   LINK_PATTERN.lastIndex = 0; // global regex stateful hota hai, reset zaroori hai
//   while ((match = LINK_PATTERN.exec(text)) !== null) {
//     const [fullMatch, label, url] = match;
//     if (match.index > lastIndex) {
//       parts.push(text.slice(lastIndex, match.index));
//     }
//     parts.push(
//       <a
//         key={`link-${key++}`}
//         href={url}
//         target="_blank"
//         rel="noopener noreferrer"
//         style={{ color: '#2563eb', textDecoration: 'underline' }}
//       >
//         {label}
//       </a>
//     );
//     lastIndex = match.index + fullMatch.length;
//   }
//   if (lastIndex < text.length) {
//     parts.push(text.slice(lastIndex));
//   }
//   return parts;
// };

// export const ADD_TYPES = ['banner', 'heading', 'text', 'image', 'button', 'columns', 'divider', 'spacer', 'social', 'footer'];
// // Types allowed INSIDE a column (no nested columns)
// export const CHILD_ADD_TYPES = ['heading', 'text', 'image', 'button', 'divider', 'spacer'];

// export const TYPE_LABELS = {
//   banner: '▬ Banner',
//   heading: 'H Heading',
//   text: '¶ Text',
//   image: '▦ Image',
//   button: '▶ Button',
//   columns: '⊞ Columns',
//   divider: '— Divider',
//   spacer: '↕ Spacer',
//   social: '◎ Social',
//   footer: '▪ Footer',
// };

// export const defaultBlock = (type) => {
//   const id = genId();
//   switch (type) {
//     case 'banner':
//       return { id, type, text: 'Your Banner Text', bgColor: '#3b82f6', textColor: '#ffffff', height: 120, align: 'center' };
//     case 'heading':
//       return { id, type, text: 'Heading text', align: 'left', color: '#111111', fontSize: 28 };
//     case 'text':
//       return { id, type, content: 'Write something here...', align: 'left', color: '#333333', fontSize: 16 };
//     case 'image':
//       return { id, type, src: '', alt: '', width: 100, align: 'center', isUploading: false };
//     case 'button':
//       return { id, type, label: 'Click Here', url: '#', bgColor: '#2563eb', textColor: '#ffffff', align: 'left' };
//     case 'columns':
//       return {
//         id,
//         type,
//         gap: 8,
//         rowBackground: 'transparent',
//         columns: [
//           { id: genId(), width: 100, background: '#ffffff', blocks: [] },
//         ],
//       };
//     case 'divider':
//       return { id, type, color: '#e5e7eb', thickness: 1 };
//     case 'spacer':
//       return { id, type, height: 24 };
//     case 'social':
//       return { id, type, align: 'center', links: [{ platform: 'Facebook', url: '#' }, { platform: 'Instagram', url: '#' }] };
//     case 'footer':
//       return { id, type, text: '© Your Company', bgColor: '#111111', textColor: '#ffffff' };
//     default:
//       return { id, type: 'text', content: '' };
//   }
// };

// const resolveImageSrc = (src) => {
//   if (!src) return '';
//   if (src.startsWith('blob:') || src.startsWith('data:') || src.startsWith('http')) {
//     return src;
//   }
//   return `${S3_BASE_URL}${src}`;
// };

// /**
//  * Pure, read-only visual output of ONE block.
//  * Used inside the editor canvas AND on the final public blog page — keeps both in sync.
//  */
// export const BlockContent = ({ block }) => {
//   switch (block.type) {
//     case 'banner':
//       return (
//         <div
//           style={{
//             background: block.bgColor,
//             color: block.textColor,
//             minHeight: block.height,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: block.align === 'center' ? 'center' : block.align === 'right' ? 'flex-end' : 'flex-start',
//             padding: '16px 24px',
//             fontSize: 22,
//             fontWeight: 600,
//             textAlign: block.align,
//           }}
//         >
//           {block.text}
//         </div>
//       );

//     case 'heading':
//       return (
//         <div style={{ padding: '12px 20px' }}>
//           <h2 style={{ color: block.color, fontSize: block.fontSize, textAlign: block.align, margin: 0 }}>{block.text}</h2>
//         </div>
//       );

//     case 'text':
//       return (
//         <div style={{ padding: '8px 20px' }}>
//           <p style={{ color: block.color, fontSize: block.fontSize, textAlign: block.align, margin: 0, whiteSpace: 'pre-wrap' }}>
//             {renderTextWithLinks(block.content)}
//           </p>
//         </div>
//       );

//     case 'image': {
//       const resolvedSrc = resolveImageSrc(block.src);
//       return (
//         <div style={{ padding: '8px 20px', textAlign: block.align, position: 'relative' }}>
//           {resolvedSrc ? (
//             <div style={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
//               <img
//                 src={resolvedSrc}
//                 alt={block.alt || ''}
//                 style={{
//                   width: `${block.width}%`,
//                   maxWidth: '100%',
//                   borderRadius: 6,
//                   opacity: block.isUploading ? 0.5 : 1,
//                   transition: 'opacity 0.2s',
//                 }}
//               />
//               {block.isUploading && (
//                 <div
//                   style={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: '50%',
//                     transform: 'translate(-50%, -50%)',
//                     background: 'rgba(0,0,0,0.6)',
//                     color: '#fff',
//                     fontSize: 11,
//                     padding: '4px 10px',
//                     borderRadius: 4,
//                   }}
//                 >
//                   Uploading...
//                 </div>
//               )}
//             </div>
//           ) : (
//             <div className="text-muted border rounded p-4 small text-center">Image not set</div>
//           )}
//         </div>
//       );
//     }

//     case 'button':
//       return (
//         <div style={{ padding: '12px 20px', textAlign: block.align }}>
//           <a
//             href={block.url}
//             onClick={(e) => e.preventDefault()}
//             style={{
//               display: 'inline-block',
//               background: block.bgColor,
//               color: block.textColor,
//               padding: '10px 22px',
//               borderRadius: 6,
//               textDecoration: 'none',
//               fontWeight: 600,
//             }}
//           >
//             {block.label}
//           </a>
//         </div>
//       );

//     case 'columns':
//       return (
//         <div style={{ display: 'flex', gap: block.gap, background: block.rowBackground, padding: 8 }}>
//           {block.columns.map((col) => (
//             <div key={col.id} style={{ width: `${col.width}%`, background: col.background, minHeight: 40 }}>
//               {col.blocks.map((child) => (
//                 <BlockContent key={child.id} block={child} />
//               ))}
//             </div>
//           ))}
//         </div>
//       );

//     case 'divider':
//       return (
//         <div style={{ padding: '10px 20px' }}>
//           <hr style={{ border: 'none', borderTop: `${block.thickness}px solid ${block.color}`, margin: 0 }} />
//         </div>
//       );

//     case 'spacer':
//       return <div style={{ height: block.height }} />;

//     case 'social':
//       return (
//         <div style={{ padding: '12px 20px', textAlign: block.align }}>
//           {block.links.map((l, i) => (
//             <a
//               key={i}
//               href={l.url}
//               onClick={(e) => e.preventDefault()}
//               style={{ marginRight: 12, fontWeight: 600, color: '#2563eb', textDecoration: 'none' }}
//             >
//               {l.platform}
//             </a>
//           ))}
//         </div>
//       );

//     case 'footer':
//       return (
//         <div style={{ background: block.bgColor, color: block.textColor, padding: '16px 20px', textAlign: 'center', fontSize: 13 }}>
//           {block.text}
//         </div>
//       );

//     default:
//       return null;
//   }
// };
















import React from 'react';

// Same bucket prefix used elsewhere in the project
export const S3_BASE_URL = 'https://s3.ap-south-1.amazonaws.com/bucket.gigbig/';

export const genId = () => `b_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

// Converts [label](url) syntax inside text-block content into clickable <a> tags
const LINK_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/g;

export const renderTextWithLinks = (text) => {
  if (!text) return null;
  const parts = [];
  let lastIndex = 0;
  let match;
  let key = 0;
  LINK_PATTERN.lastIndex = 0; // global regex is stateful, reset is required
  while ((match = LINK_PATTERN.exec(text)) !== null) {
    const [fullMatch, label, url] = match;
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    parts.push(
      <a
        key={`link-${key++}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#2563eb', textDecoration: 'underline' }}
      >
        {label}
      </a>
    );
    lastIndex = match.index + fullMatch.length;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts;
};

export const ADD_TYPES = ['banner', 'heading', 'text', 'image', 'button', 'columns', 'divider', 'spacer', 'social', 'footer'];
// Types allowed INSIDE a column (no nested columns)
export const CHILD_ADD_TYPES = ['heading', 'text', 'image', 'button', 'divider', 'spacer'];

export const TYPE_LABELS = {
  banner: '▬ Banner',
  heading: 'H Heading',
  text: '¶ Text',
  image: '▦ Image',
  button: '▶ Button',
  columns: '⊞ Columns',
  divider: '— Divider',
  spacer: '↕ Spacer',
  social: '◎ Social',
  footer: '▪ Footer',
};

export const defaultBlock = (type) => {
  const id = genId();
  switch (type) {
    case 'banner':
      return { id, type, text: 'Your Banner Text', bgColor: '#3b82f6', textColor: '#ffffff', height: 120, align: 'center' };
    case 'heading':
      return { id, type, text: 'Heading text', align: 'left', color: '#111111', fontSize: 28 };
    case 'text':
      return { id, type, content: 'Write something here...', align: 'left', color: '#333333', fontSize: 16 };
    case 'image':
      return { id, type, src: '', alt: '', width: 100, align: 'center', isUploading: false };
    case 'button':
      return { id, type, label: 'Click Here', url: '#', bgColor: '#2563eb', textColor: '#ffffff', align: 'left' };
    case 'columns':
      return {
        id,
        type,
        gap: 8,
        rowBackground: 'transparent',
        columns: [
          { id: genId(), width: 100, background: '#ffffff', blocks: [] },
        ],
      };
    case 'divider':
      return { id, type, color: '#e5e7eb', thickness: 1 };
    case 'spacer':
      return { id, type, height: 24 };
    case 'social':
      return { id, type, align: 'center', links: [{ platform: 'Facebook', url: '#' }, { platform: 'Instagram', url: '#' }] };
    case 'footer':
      return { id, type, text: '© Your Company', bgColor: '#111111', textColor: '#ffffff' };
    default:
      return { id, type: 'text', content: '' };
  }
};

const resolveImageSrc = (src) => {
  if (!src) return '';
  if (src.startsWith('blob:') || src.startsWith('data:') || src.startsWith('http')) {
    return src;
  }
  return `${S3_BASE_URL}${src}`;
};

/**
 * Pure, read-only visual output of ONE block.
 * Used inside the editor canvas AND on the final public blog page — keeps both in sync.
 */
export const BlockContent = ({ block }) => {
  switch (block.type) {
    case 'banner':
      return (
        <div
          style={{
            background: block.bgColor,
            color: block.textColor,
            minHeight: block.height,
            display: 'flex',
            alignItems: 'center',
            justifyContent: block.align === 'center' ? 'center' : block.align === 'right' ? 'flex-end' : 'flex-start',
            padding: '16px 24px',
            fontSize: 22,
            fontWeight: 600,
            textAlign: block.align,
          }}
        >
          {block.text}
        </div>
      );

    case 'heading':
      return (
        <div style={{ padding: '12px 20px' }}>
          <h2 style={{ color: block.color, fontSize: block.fontSize, textAlign: block.align, margin: 0 }}>{block.text}</h2>
        </div>
      );

    case 'text':
      return (
        <div style={{ padding: '8px 20px' }}>
          <p style={{ color: block.color, fontSize: block.fontSize, textAlign: block.align, margin: 0, whiteSpace: 'pre-wrap' }}>
            {renderTextWithLinks(block.content)}
          </p>
        </div>
      );

    case 'image': {
      const resolvedSrc = resolveImageSrc(block.src);
      return (
        <div style={{ padding: '8px 20px', textAlign: block.align, position: 'relative' }}>
          {resolvedSrc ? (
            <div style={{ position: 'relative', display: 'inline-block', maxWidth: '100%' }}>
              <img
                src={resolvedSrc}
                alt={block.alt || ''}
                style={{
                  width: `${block.width}%`,
                  maxWidth: '100%',
                  borderRadius: 6,
                  opacity: block.isUploading ? 0.5 : 1,
                  transition: 'opacity 0.2s',
                }}
              />
              {block.isUploading && (
                <div
                  style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'rgba(0,0,0,0.6)',
                    color: '#fff',
                    fontSize: 11,
                    padding: '4px 10px',
                    borderRadius: 4,
                  }}
                >
                  Uploading...
                </div>
              )}
            </div>
          ) : (
            <div className="text-muted border rounded p-4 small text-center">Image not set</div>
          )}
        </div>
      );
    }

    case 'button':
      return (
        <div style={{ padding: '12px 20px', textAlign: block.align }}>
          <a
            href={block.url}
            onClick={(e) => e.preventDefault()}
            style={{
              display: 'inline-block',
              background: block.bgColor,
              color: block.textColor,
              padding: '10px 22px',
              borderRadius: 6,
              textDecoration: 'none',
              fontWeight: 600,
            }}
          >
            {block.label}
          </a>
        </div>
      );

    case 'columns':
      return (
        <div style={{ display: 'flex', gap: block.gap, background: block.rowBackground, padding: 8 }}>
          {block.columns.map((col) => (
            <div key={col.id} style={{ width: `${col.width}%`, background: col.background, minHeight: 40 }}>
              {col.blocks.map((child) => (
                <BlockContent key={child.id} block={child} />
              ))}
            </div>
          ))}
        </div>
      );

    case 'divider':
      return (
        <div style={{ padding: '10px 20px' }}>
          <hr style={{ border: 'none', borderTop: `${block.thickness}px solid ${block.color}`, margin: 0 }} />
        </div>
      );

    case 'spacer':
      return <div style={{ height: block.height }} />;

    case 'social':
      return (
        <div style={{ padding: '12px 20px', textAlign: block.align }}>
          {block.links.map((l, i) => (
            <a
              key={i}
              href={l.url}
              onClick={(e) => e.preventDefault()}
              style={{ marginRight: 12, fontWeight: 600, color: '#2563eb', textDecoration: 'none' }}
            >
              {l.platform}
            </a>
          ))}
        </div>
      );

    case 'footer':
      return (
        <div style={{ background: block.bgColor, color: block.textColor, padding: '16px 20px', textAlign: 'center', fontSize: 13 }}>
          {block.text}
        </div>
      );

    default:
      return null;
  }
};